import { toKnownSource, type RadarSourceKey } from "@modules/radar/radar.types";
import type { ContactActivity200 } from "@shared/generated/radar/models/contactsController/ContactActivity";

export type RadarFeedItem = ContactActivity200["items"][number];

export const RESEARCH_FAILED_FALLBACK_MESSAGE =
  "Couldn't complete this research — will retry automatically";

export type MomentCardViewModel = {
  id: string;
  // Radar's own contact.id is internal; externalId is the CRM contact id
  // that /contacts/:id navigation elsewhere in the app expects.
  contactId: string | null;
  contactName: string;
  source?: RadarSourceKey;
  isResearching: boolean;
  hasFailed: boolean;
  errorMessage: string | null;
  headline: string | null;
  score: number | null;
  insight: string | null;
  nextStep: string | null;
  occurredAt: string | null;
};

export function toMomentCardViewModel(
  item: RadarFeedItem,
): MomentCardViewModel {
  const mostRecentEvent = item.events[0] ?? null;

  return {
    id: item.contact.id,
    contactId: item.contact.externalId,
    contactName: item.contact.name ?? "Unknown",
    source: mostRecentEvent ? toKnownSource(mostRecentEvent.source) : undefined,
    isResearching: !item.lastExecution && !mostRecentEvent,
    hasFailed:
      (item.lastExecution?.status === "failed" ||
        item.lastExecution?.status === "timeout") &&
      !mostRecentEvent,
    errorMessage: item.lastExecution?.errorMessage ?? null,
    headline: mostRecentEvent?.description ?? null,
    score: item.lastExecution?.priorityScore ?? null,
    insight: item.lastExecution?.insights?.[0] ?? null,
    nextStep:
      item.lastExecution?.lastEventFollowUp ??
      item.lastExecution?.suggestedApproach ??
      null,
    occurredAt:
      mostRecentEvent?.eventDate ?? item.lastExecution?.executedAt ?? null,
  };
}
